import { fetchFromUrlPOSTAsync } from '../utils/UrlHelper';

const DEVICE = 'mobile';

const URL_REGISTER = '/users/auth/register';
const URL_LOGIN = '/users/auth/login';
const URL_LOGOUT = '/users/auth/logout';
const URL_PROFILE = '/users/auth/profile';

const deviceParams = (deviceKey) => {
  return {
    device: DEVICE,
    deviceKey: (deviceKey !== null && deviceKey !== undefined && deviceKey !== '') 
      ? String(deviceKey) 
      : 'fallback_device_key',
  };
};

const fs = {
  register: async (saveData, deviceKey) => {
    const result = await fetchFromUrlPOSTAsync(URL_REGISTER, {
      ...deviceParams(deviceKey),
      saveData,
    });
    return result;
  },
  login: async (phoneNumber, deviceKey) => {
    const result = await fetchFromUrlPOSTAsync(URL_LOGIN, {
      ...deviceParams(deviceKey),
      phone_number: phoneNumber,
    });
    return result;
  },
  logout: async (deviceKey) => {
    const result = await fetchFromUrlPOSTAsync(URL_LOGOUT, {
      ...deviceParams(deviceKey),
    });
    return result;
  },
  updateProfile: async (saveData, deviceKey) => {
    const result = await fetchFromUrlPOSTAsync(URL_PROFILE, {
      ...deviceParams(deviceKey),
      saveData,
    });
    return result;
  },
};

const loc = {
  NOTIFICATION_PREFERENCE: {
    WHATSAPP: 'WHATSAPP',
    TELEGRAM: 'TELEGRAM',
    BOTH: 'BOTH',
  },
};

const ParkingAuthActions = Object.assign(fs, loc);

export default ParkingAuthActions;